export default __webpack_public_path__ + "static/media/second_order_with_zero.814eb879.svg";